import React from 'react';

import { Anchor, Group, Text } from '@mantine/core';

import { EmergeAlliance } from 'components/icons/certification/EmergeAlliance';

import cx from './EMergeAllianceNotice.module.scss';

const EMergeAllianceNotice = () => (
    <Group gap={6} wrap="nowrap" justify="center" className={cx.tab}>
        <Anchor href="https://www.emergealliance.org/" target="_blank" className={cx.logo}>
            <EmergeAlliance size={18} />
        </Anchor>
        <Text fz="xs" c="dimmed" hiddenFrom="sm">
            Based on the <InteroperabilityDataModelLink />
        </Text>
        <Text fz="xs" c="dimmed" visibleFrom="sm">
            Follows the open <InteroperabilityDataModelLink />, maintained by the{' '}
            <Anchor
                href="https://www.emergealliance.org/"
                target="_blank"
                inherit
                fw={600}
                style={{ whiteSpace: 'nowrap' }}
            >
                EMerge Alliance
            </Anchor>
        </Text>
    </Group>
);

const InteroperabilityDataModelLink = () => (
    <Anchor
        href="https://github.com/Direct-Energy-Partners/interoperability-data-model"
        target="_blank"
        inherit
        fw={600}
    >
        Interoperability Data Model
    </Anchor>
);

export { EMergeAllianceNotice };
